import { useMutation, useQuery } from '@tanstack/react-query';

import { useLocalization } from 'localization';
import notifyHandler from 'utils/notifyHandler';
import AuthApi from '.';
import { IUserDto } from 'api/users/dtos';
import { datahubAxiosClient, MAIN_USER_ENDPOINT } from 'constants/server/apiEndPoint';

type AuthProps = {
  email: string;
  appRoute: string;
};

export const authQueryKey = {
  all: ['auth'] as const,
  user: ['user'] as const,
  mainUser: () => [...authQueryKey.all, 'mainUser'] as const,
};

export const authApiMutation = () => {
  const { t } = useLocalization();
  const { mutateAsync, isSuccess, ...restMutation } = useMutation({
    mutationFn: async ({ email, appRoute }: AuthProps) => {
      const lowerEmail = email.toLowerCase();
      const isEsoftEmail = lowerEmail.endsWith('@esoft.com') || lowerEmail.endsWith('@efkt.com');

      const response = isEsoftEmail ? await AuthApi.esoftAuth(appRoute) : await AuthApi.b2cAuth(lowerEmail, appRoute);
      return response;
    },
    onSuccess: (response: Awaited<ReturnType<typeof AuthApi.esoftAuth>>) => {
      if (response?.loginUrl) {
        window.location.href = response.loginUrl;
      }
    },
    onError: () => {
      notifyHandler({ type: 'error', content: t('auth.pages.activeDirectory.errorGettingUser') });
    },
  });

  return { mutateAsync, isSuccess, ...restMutation };
};

export const getMainUserApi = () => {
  const { data } = useQuery<IUserDto>({
    queryKey: authQueryKey.mainUser(),
    queryFn: async () => {
      const response = await datahubAxiosClient.get(MAIN_USER_ENDPOINT);
      return response.data;
    },
    enabled: AuthApi.isAuthenticated(),
  });

  return { data };
};
